export default __webpack_public_path__ + "static/media/calendar-black-icon.593aa70c.svg";